import styled from 'styled-components';
import { withRouter } from 'react-router-dom'

import logo from './resources/avatar-transparent.png';

import Background from './components/Background';

const Home = withRouter(() => {

  return <>
    <Background>
      <CenteredComponent>
        <VerticalWrapper>
          <LogoCircle>
            <Logo src={logo} alt={'LOGO'}/>
          </LogoCircle>
        </VerticalWrapper>
      </CenteredComponent>
    </Background>
  </>
});

const CenteredComponent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: 100vh;
`

const VerticalWrapper = styled.div`
  display: flex;
  flex-direction: column;
`

const LogoCircle = styled.div`
  background-color: #DDDDDD;
  height: 400px;
  width: 400px;
  border-radius: 50%;
  transition: .8s;
  cursor: default
  filter: none;
  &:hover {
    filter: drop-shadow(0px 8px 8px black);
  }
`
const Logo = styled.img`
  height: 400px;
  width: 400px;
  transition: .8s;
  filter: grayscale(100%) blur(2px);
  &:hover {
    filter: none;
  }
`

const HorizontalWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-left: 12px;
  visibility: ${props => props.visibile ? 'visibile' : 'hidden'}
`

export default Home;